import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ImportSummary, ListResponse } from '@shared/schemas';

import { initialState } from './imports.state';

/**
 * Imports Index slice. Reducers are pure state transitions only; the fetch
 * itself lives in the saga, which dispatches these `load*` transitions as it
 * progresses.
 */
const slice = createSlice({
  name: 'imports',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.loading = true;
      state.error = null;
    },
    /** Newest import first; the sort the old `useApi` callback applied. */
    loadSucceeded: (
      state,
      action: PayloadAction<{ rows: ListResponse[]; summary: ImportSummary }>,
    ) => {
      state.rows = [...action.payload.rows].sort((a, b) =>
        b.created_at.localeCompare(a.created_at),
      );
      state.summary = action.payload.summary;
      state.loading = false;
    },
    loadFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    /** A fresh form: nothing sent yet, no error left from a previous attempt. */
    csmMessageReset: (state) => {
      state.csmMessage = { status: 'idle', error: null };
    },
    csmMessageSending: (state) => {
      state.csmMessage = { status: 'sending', error: null };
    },
    csmMessageSent: (state) => {
      state.csmMessage = { status: 'sent', error: null };
    },
    csmMessageFailed: (state, action: PayloadAction<string>) => {
      state.csmMessage = { status: 'failed', error: action.payload };
    },
  },
});

export const importsActions = slice.actions;
export const importsReducer = slice.reducer;
